import { Notification } from '@alf/uikit';
import { WithdrawalLimitToastMessage } from './components/WithdrawalLimitToastMessage';
import { useWithdrawalLimitToast } from './hooks/useWithdrawalLimitToast';

import styles from './index.module.css';

export const WithdrawalLimitToast = () => {
  const { isPassportInVerification, onClick, onClose } =
    useWithdrawalLimitToast();

  return (
    <Notification
      message={
        <WithdrawalLimitToastMessage
          isPassportInVerification={isPassportInVerification}
          onClick={onClick}
        />
      }
      onClose={onClose}
      className={styles.notification}
      closeIconClassName={styles.closeIcon}
    />
  );
};
